// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"46ce228e","327":"af905ea5","453":"94c68ba6","773":"a70f6318"}[chunkId] + ".chunk.js";
};